import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm$dbSyncedDashboard;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    attrs: {
      width: "800",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [!_vm.isAnyFocused && !_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v(" " + _vm._s(_vm.isEditingDashboard ? "Edit dashboard" : "Add new dashboard") + " ")])]), _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "flex mb-3 items-baseline"
  }, [_c(VAutocomplete, {
    staticClass: "v-text-field --smaller",
    attrs: {
      disabled: _vm.gettingRegions.isPending,
      readonly: _vm.isUpdatingConfiguration,
      label: _vm.gettingRegions.isPending ? "Loading..." : "Add all producers of region",
      items: _vm.gettingRegions.results,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "displayName",
      "item-value": "id",
      "hide-details": "auto",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.regionIdForProducers,
      callback: function callback($$v) {
        _vm.regionIdForProducers = $$v;
      },
      expression: "regionIdForProducers"
    }
  }), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary ml-2",
    attrs: {
      disabled: !_vm.regionIdForProducers,
      rounded: ""
    },
    on: {
      click: _vm.addProducersOfRegion
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add producers ")], 1)], 1), _c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c(VAutocomplete, {
    staticClass: "v-text-field required",
    attrs: {
      disabled: _vm.wineries.isLoading,
      readonly: _vm.isUpdatingConfiguration,
      label: _vm.wineries.isLoading ? "Loading..." : "Producer(s)",
      items: _vm.wineries.items,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "name",
      "item-value": "id",
      "hide-details": "auto",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      clearable: "",
      filter: _vm.filterVAutocomplete,
      rules: [_vm.formRules.mustSelectValue],
      "search-input": _vm.vAutocompleteSearchValue
    },
    on: {
      focus: function focus($event) {
        _vm.isWineryIdsFocused = true;
      },
      blur: function blur($event) {
        _vm.vAutocompleteSearchValue = "";
        _vm.isWineryIdsFocused = false;
        _vm.checkChangeConfiguration();
      },
      change: function change($event) {
        _vm.vAutocompleteSearchValue = "";
      },
      "update:searchInput": function updateSearchInput($event) {
        _vm.vAutocompleteSearchValue = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.vAutocompleteSearchValue = $event;
      }
    },
    model: {
      value: _vm.form.wineryIds,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "wineryIds", $$v);
      },
      expression: "form.wineryIds"
    }
  }), _c(VTextField, {
    attrs: {
      readonly: _vm.isUpdatingCustomTitle,
      label: "Custom title",
      placeholder: "Define the title of the page, or let empty to get auto title",
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      focus: function focus($event) {
        _vm.isCustomTitleFocused = true;
      },
      blur: function blur($event) {
        _vm.isCustomTitleFocused = false;
        _vm.checkChangeCustomTitle();
      }
    },
    model: {
      value: _vm.form.customTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customTitle", $$v);
      },
      expression: "form.customTitle"
    }
  }), _c("div", {
    staticClass: "d-flex align-center mt-4"
  }, [_c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      readonly: _vm.isUpdatingConfiguration,
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.checkChangeConfiguration();
      }
    },
    model: {
      value: _vm.form.isShowTurnover,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isShowTurnover", $$v);
      },
      expression: "form.isShowTurnover"
    }
  }), !_vm.form.isShowTurnover ? _c("span", {
    staticClass: "text-red text-bold"
  }, [_vm._v(" WILL HIDE the amount of turnover in the dashboard and export file ")]) : _c("span", {
    staticClass: "text-green text-bold"
  }, [_vm._v(" Will SHOW the amount of turnover in the dashboard and export file ")])], 1), _c(VCheckbox, {
    attrs: {
      readonly: _vm.isUpdatingActivationStatus,
      label: "Active",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.checkChangeActivationStatus();
      }
    },
    model: {
      value: _vm.form.isActive,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isActive", $$v);
      },
      expression: "form.isActive"
    }
  })], 1), _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyFocused || _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  }, [_vm._v(" Close ")]), !_vm.isEditingDashboard ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: !_vm.form.valid,
      loading: _vm.isAdding
    },
    on: {
      click: function click($event) {
        return _vm.addDashboard();
      }
    }
  }, [_vm._v(" Create dashboard ")]) : _vm.isEditingDashboard && !((_vm$dbSyncedDashboard = _vm.dbSyncedDashboard) !== null && _vm$dbSyncedDashboard !== void 0 && _vm$dbSyncedDashboard.isActive) ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      loading: _vm.isDeletingDashboard
    },
    on: {
      click: function click($event) {
        return _vm.confirmDeleteDashboard();
      }
    }
  }, [_vm._v(" Delete dashboard ")]) : _vm._e()], 1)], 1)], 1)], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };